import {authAxios} from "./axiosClient";
import {
        autoAttendURL,
} from "../constants";

export const autoAttendApi = (params={})=>{
        return authAxios().get(autoAttendURL,{params})
}

export const PostAutoAttendApi = (params={})=>{
        const url = autoAttendURL;
        return authAxios().post(url,params);
}

export const DeleteAutoAttendApi = (params={})=>{
        const url = autoAttendURL;
        return authAxios().delete(url,{data:params});
}